var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312 387",
    width: 312,
    height: 387,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eacc_marca_opcion_01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #97d700 } \n\t\t.s2 { fill: #076c3f } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m198.2 22.2l-27 15.6 80.1 46.3v-15.6c0-9.7-5.1-18.6-13.5-23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m224.3 176.7l13.5-7.8c8.4-4.8 13.5-13.7 13.5-23.4v-45.8l-27-15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m171.2 207.4l39.6-22.8v-31.3l-80.2 46.3 13.5 7.8c8.4 4.9 18.7 4.9 27.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m64 129.9v15.6c0 9.7 5.2 18.6 13.5 23.4l39.6 22.9 27-15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m91 37.3l-13.5 7.8c-8.3 4.8-13.5 13.7-13.5 23.4v45.8l27 15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m144.1 6.6l-39.5 22.8v31.3l80.1-46.3-13.5-7.8c-8.4-4.9-18.7-4.9-27.1 0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f0"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    filter: "url(#f0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m2.2 380.7v-21.5h9.4v2.2h-7v7.1h6.2v2.1h-6.2v8h7.3v2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m17 373.1l-4-6.7h2.5l2.9 5.1 2.8-5.1h2.4l-4 6.8 4.4 7.5h-2.5l-3.4-5.9-3.3 5.9h-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m33.9 380.7l-0.1-1.5q-0.8 1-1.6 1.4-0.9 0.4-2.2 0.4-3 0-4.1-2.1-1.1-2-1.1-5.3 0-3.4 1.1-5.4 1.1-2.1 4.1-2.1 2.7 0 3.8 1.8l0.1-1.5h1.9v14.3zm-3.6-12.6q-1.8 0-2.4 1.4-0.7 1.5-0.7 4.1 0 2.9 0.7 4.1 0.7 1.3 2.4 1.3 1.9 0 2.5-1.4 0.7-1.4 0.7-4 0-2.9-0.7-4.2-0.8-1.3-2.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m54.8 375.1h-7.6l-1.8 5.6h-2.4l7-21.7h2l7 21.7h-2.4zm-0.5-2l-3.3-10.7-3.4 10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m59.4 377.7l1.9-0.7q0.9 2.2 2.8 2.2 2.1 0 2.1-2.2 0-0.9-0.5-1.4-0.6-0.6-2.4-1.4-1.7-0.8-2.3-1.6-0.9-1-0.9-2.6 0-1.8 1-2.9 1.1-1 2.9-1 2.7 0 3.9 2.3l-1.7 0.9q-0.8-1.4-2.1-1.4-0.9 0-1.4 0.5-0.5 0.5-0.5 1.4 0 1.1 0.7 1.7 0.4 0.2 1.9 0.9 1.8 0.8 2.5 1.5 1.1 1 1.1 2.9 0 2-1.1 3-1.1 1.2-3.2 1.2-1.8 0-2.9-0.7-1.1-0.8-1.8-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m69.4 377.7l2-0.7q0.8 2.2 2.7 2.2 2.1 0 2.1-2.2 0-0.9-0.5-1.4-0.6-0.6-2.4-1.4-1.6-0.8-2.3-1.6-0.9-1-0.9-2.6 0-1.8 1.1-2.9 1-1 2.8-1 2.7 0 3.9 2.3l-1.6 0.9q-0.9-1.4-2.2-1.4-0.9 0-1.4 0.5-0.5 0.5-0.5 1.4 0 1.1 0.7 1.7 0.4 0.2 1.9 0.9 1.8 0.8 2.5 1.5 1.1 1 1.1 2.9 0 2-1 3-1.2 1.2-3.3 1.2-1.8 0-2.9-0.7-1.1-0.8-1.8-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m91.2 374.1h-8.9q0 2.6 0.8 3.8 0.8 1.2 2.6 1.2 2.6 0 3.2-2.3l2.2 0.4q-1.1 3.8-5.3 3.8-3.3 0-4.6-2.1-1.2-1.9-1.2-5.3 0-3.4 1.2-5.4 1.3-2.1 4.5-2.1 3.1 0 4.4 2.1 1.1 2 1.1 4.9 0 0.4 0 1zm-2.2-1.8q-0.1-1.5-0.4-2.3-0.3-1-1-1.5-0.7-0.4-1.9-0.4-1.3 0-2 0.5-0.8 0.5-1.1 1.7-0.3 0.9-0.3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m94 368.5h-1.5v-2.1h1.5l0.2-4.3 2-0.5v4.8h2.5v2.1h-2.5v8q0 1.3 0.3 1.8 0.2 0.4 1 0.4 0.4 0 0.9-0.1v2.1q-0.8 0.1-1.5 0.1-1.9 0-2.5-1.3-0.4-0.9-0.4-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m117.6 376.6l1.6 1.3q-0.7 1.1-1.5 1.7-1.8 1.4-4.7 1.4-4.2 0-5.9-3-1.7-2.9-1.7-8 0-4.9 1.5-7.8 1.8-3.3 6.1-3.3 3.9 0 5.9 3.1l-1.6 1.4q-1.5-2.3-4.1-2.3-2.8 0-4 2.1-1.3 2.2-1.3 6.8 0 3.9 1 6.2 1.2 2.7 4.4 2.7 2.7 0 4.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m126 366.1q3.3 0 4.6 2.1 1.2 1.9 1.2 5.4 0 3.4-1.2 5.3-1.3 2.1-4.6 2.1-3.3 0-4.6-2.1-1.1-1.9-1.1-5.4 0-3.4 1.1-5.3 1.4-2.1 4.6-2.1zm0 2q-2 0-2.7 1.4-0.7 1.4-0.7 4 0 3 0.8 4.2 0.8 1.3 2.6 1.3 2 0 2.7-1.4 0.8-1.4 0.8-4 0-2.9-0.8-4.2-0.8-1.3-2.7-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m134.3 380.7v-14.3h2.1l0.1 1.6q1.3-1.9 4-1.9 2.4 0 3.4 1.5 1 1.4 1 5.1v8h-2.3v-7.5q0-2.8-0.5-3.9-0.6-1.1-2.2-1.1-2 0-2.8 1.9-0.5 1.2-0.5 4v6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m148.3 368.5h-1.4v-2.1h1.5l0.1-4.3 2.1-0.5v4.8h2.4v2.1h-2.4v8q0 1.3 0.2 1.8 0.3 0.4 1 0.4 0.5 0 1-0.1v2.1q-0.8 0.1-1.6 0.1-1.8 0-2.4-1.3-0.5-0.9-0.5-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m154.9 380.7v-14.3h2.1l0.1 1.7q1.1-1.9 3.3-1.9 0.4 0 1 0.1v2.1q-0.7-0.1-1.1-0.1-0.9 0-1.6 0.5-0.7 0.5-1 1.4-0.5 1.2-0.5 3.9v6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m168.3 366.1q3.3 0 4.6 2.1 1.2 1.9 1.2 5.4 0 3.4-1.2 5.3-1.3 2.1-4.6 2.1-3.3 0-4.6-2.1-1.2-1.9-1.2-5.4 0-3.4 1.2-5.3 1.3-2.1 4.6-2.1zm0 2q-2 0-2.7 1.4-0.8 1.4-0.8 4 0 3 0.8 4.2 0.8 1.3 2.7 1.3 2 0 2.7-1.4 0.7-1.4 0.7-4 0-2.9-0.8-4.2-0.8-1.3-2.6-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m176.5 380.7v-21.5h2.3v21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m199.1 376.6l1.6 1.3q-0.7 1.1-1.5 1.7-1.8 1.4-4.7 1.4-4.2 0-5.9-3-1.7-2.9-1.7-8 0-4.9 1.5-7.8 1.8-3.3 6.1-3.3 3.9 0 5.9 3.1l-1.6 1.4q-1.5-2.3-4.1-2.3-2.7 0-4 2.1-1.3 2.2-1.3 6.8 0 3.9 1 6.2 1.2 2.7 4.4 2.7 2.7 0 4.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m207.5 366.1q3.3 0 4.6 2.1 1.2 1.9 1.2 5.4 0 3.4-1.2 5.3-1.3 2.1-4.5 2.1-3.3 0-4.6-2.1-1.2-1.9-1.2-5.4 0-3.4 1.2-5.3 1.3-2.1 4.5-2.1zm0 2q-2 0-2.7 1.4-0.7 1.4-0.7 4 0 3 0.8 4.2 0.8 1.3 2.6 1.3 2.1 0 2.8-1.4 0.7-1.4 0.7-4 0-2.9-0.8-4.2-0.8-1.3-2.7-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m215.8 380.7v-14.3h2.1l0.1 1.6q1.2-1.9 3.8-1.9 2.8 0 3.5 2.2 1.5-2.2 4.2-2.2 2.3 0 3.2 1.5 0.9 1.4 0.9 5.1v8h-2.3v-7.5q0-2.8-0.5-3.9-0.5-1.1-1.8-1.1-0.9 0-1.6 0.5-0.7 0.5-1.1 1.4-0.5 1.2-0.5 3.9v6.7h-2.2v-7.5q0-2.8-0.5-3.9-0.5-1.1-1.9-1.1-0.9 0-1.6 0.5-0.7 0.5-1 1.4-0.5 1.2-0.5 4v6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m239 379.5v8.7h-2.3v-21.8h1.9l0.1 1.5q1-1.8 3.7-1.8 3.1 0 4.2 2.1 1.1 2 1.1 5.4 0 3.3-1.1 5.3-1.1 2.1-4.1 2.1-1.2 0-2-0.3-0.7-0.3-1.5-1.2zm3.2-11.4q-1.9 0-2.5 1.4-0.7 1.4-0.7 4 0 3 0.7 4.2 0.8 1.3 2.5 1.3 1.8 0 2.5-1.4 0.6-1.4 0.6-4 0-2.7-0.6-4.1-0.7-1.4-2.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m250.2 380.7v-21.5h2.2v21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m256.8 360.3q0.7 0 1.2 0.4 0.4 0.4 0.4 1.1 0 0.7-0.4 1.1-0.5 0.4-1.2 0.4-0.7 0-1.1-0.4-0.4-0.4-0.4-1.1 0-0.7 0.4-1.1 0.5-0.4 1.1-0.4zm-1.1 20.4v-14.3h2.3v14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m269.5 380.7l-0.1-1.5q-0.7 1-1.6 1.4-0.8 0.4-2.1 0.4-3 0-4.1-2.1-1.1-2-1.1-5.3 0-3.4 1.1-5.4 1.1-2.1 4-2.1 2.7 0 3.8 1.8l0.1-1.5h1.9v14.3zm-3.5-12.6q-1.9 0-2.5 1.4-0.7 1.5-0.7 4.1 0 2.9 0.7 4.1 0.8 1.3 2.5 1.3 1.8 0 2.5-1.4 0.7-1.4 0.7-4 0-2.9-0.8-4.2-0.7-1.3-2.4-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m274.7 380.7v-14.3h2l0.1 1.6q1.3-1.9 4.1-1.9 2.4 0 3.4 1.5 1 1.4 1 5.1v8h-2.3v-7.5q0-2.8-0.6-3.9-0.5-1.1-2.1-1.1-2 0-2.8 1.9-0.6 1.2-0.6 4v6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m296.2 377.5l1.6 1.2q-0.6 0.9-1.2 1.3-1.3 1-3.4 1-2 0-3.3-0.9-2.2-1.6-2.2-6.5 0-3.5 1.1-5.4 1.3-2.1 4.3-2.1 1.6 0 2.7 0.6 1 0.5 1.8 1.8l-1.6 1.2q-0.4-0.6-0.7-0.9-0.7-0.7-2-0.7-1.7 0-2.5 1.3-0.8 1.3-0.8 4.2 0 2.8 0.8 4.1 0.8 1.3 2.4 1.3 2 0 3-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m310 374.1h-8.9q0 2.6 0.8 3.8 0.9 1.2 2.7 1.2 2.6 0 3.1-2.3l2.2 0.4q-1.1 3.8-5.2 3.8-3.4 0-4.7-2.1-1.2-1.9-1.2-5.3 0-3.4 1.2-5.4 1.3-2.1 4.5-2.1 3.1 0 4.4 2.1 1.1 2 1.1 4.9 0 0.4 0 1zm-2.2-1.8q-0.1-1.5-0.4-2.3-0.3-1-1-1.5-0.7-0.4-1.9-0.4-1.3 0-2 0.5-0.7 0.5-1.1 1.7-0.2 0.9-0.3 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m2.2 343.1v-75.2h54v16.3h-35.6v12.1h31v16.3h-31v14.2h37.2v16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m83.2 343.1h-20l37.6-76.3h14.4l37.6 76.3h-19.9l-24.9-54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m216.8 319.3l13.2 11.4q-5.4 5.5-9.7 8.1-9.9 5.8-25.8 5.8-20.3 0-31.5-9.3-6.3-5.3-8.9-12.8-2.5-7.6-2.5-17.1 0-18.4 10.3-28.3 11.1-10.7 31.6-10.7 15.3 0 25.9 6.5 4.6 2.9 9 7.6l-12.4 11.6q-4.2-4.9-9.2-7.1-4.9-2.2-12.1-2.2-23.5 0-23.5 23.3 0 10.1 4.7 15.6 3.6 4.1 8.9 5.4 5 1.2 11.2 1.2 8.7 0 14.6-3.5 3.4-2 6.2-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m296.8 319.3l13.2 11.4q-5.4 5.5-9.7 8.1-9.9 5.8-25.8 5.8-20.3 0-31.5-9.3-6.4-5.3-8.9-12.8-2.5-7.6-2.5-17.1 0-18.4 10.3-28.3 11.1-10.7 31.6-10.7 15.3 0 25.9 6.5 4.5 2.9 8.9 7.6l-12.3 11.6q-4.2-4.9-9.2-7.1-4.9-2.2-12.2-2.2-23.4 0-23.4 23.3 0 10.1 4.7 15.6 3.5 4.1 8.9 5.4 5 1.2 11.2 1.2 8.7 0 14.6-3.5 3.4-2 6.2-5.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.e000e36765fd61208022aedd1b5ad990.svg";
export { ForwardRef as ReactComponent };